import React from 'react';

import AnimateReveal from '../AnimateReveal/AnimateReveal';
import Cover, { coverThemes } from '../Cover/Cover';
import Link from '../UI/Link/Link';
import Teaser from '../UI/Teaser/Teaser';
import WpImage from '../UI/WpImage/WpImage';
import { motion } from '../UI/framer-motion-custom';
import * as styles from './ArticleCover.module.scss';

const imageVariants = {
  hidden: { opacity: 0, y: '100%' },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: 'easeOut',
      delay: 0.7,
      when: 'beforeChildren',
      staggerChildren: 0.15,
    },
  },
};

const ArticleCover = ({ teaser, heading, author, image }) => {
  return (
    <Cover theme={coverThemes.TAN} reveal={false} hasHeaderOffset={false}>
      <div className={styles.container}>
        <AnimateReveal
          className={styles.body}
          staggerChildren={true}
          at="100px"
        >
          <Teaser>{teaser}</Teaser>
          <motion.h1 className={styles.heading}>{heading}</motion.h1>
          <motion.p className={styles.byline}>
            By <Link to={author.uri}>{author.name}</Link>
          </motion.p>
        </AnimateReveal>

        {image && (
          <AnimateReveal
            className={styles.imageContainer}
            variants={imageVariants}
            at="200px"
          >
            <WpImage className={styles.image} {...image} />
          </AnimateReveal>
        )}
      </div>
    </Cover>
  );
};

export default ArticleCover;
